import type { ImmerStateCreator } from 'hooks/useStore';

export interface TicketingPermissionSlice {
  selectedBoardId: string;
  // user has "Ticket Admin Permissions" checked bot not in a group/member on the selected board
  onlyAdminPermissionAccess: boolean;
  setSelectedBoardId: (id: string) => void;
  setOnlyAdminPermissionAccess: (isOnlyAdminPermissionAccess: boolean) => void;
}

export const useTicketingPermissionsSlice: ImmerStateCreator<
  TicketingPermissionSlice
> = (set) => ({
  selectedBoardId: '',
  onlyAdminPermissionAccess: false,
  setSelectedBoardId: (id: string) =>
    set(
      (state) => {
        state.ticketingPermissionsSlice.selectedBoardId = id;
      },
      false,
      'setSelectedBoardId'
    ),
  setOnlyAdminPermissionAccess: (isOnlyAdminPermissionAccess: boolean) =>
    set(
      (state) => {
        state.ticketingPermissionsSlice.onlyAdminPermissionAccess =
          isOnlyAdminPermissionAccess;
      },
      false,
      'setOnlyAdminPermissionAccess'
    ),
});
